import { useEffect, useState } from 'react';
import { Table } from 'antd';

import { lookerHttp, LookerRecord } from '@network';
import { axiosErrorToString } from '@utils';
import { makeStyles } from '@mui/styles';
import { ErrorMessage, Loader } from '@components';

interface Props {
  title: string;
  lookId: number;
  version: number;
  creditCodes: Record<number, string>;
}

export const Look = ({ title, lookId, version, creditCodes }: Props) => {
  const [records, setRecords] = useState<LookerRecord[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const cls = useStyles();

  const loadRecords = async () => {
    setLoading(true);
    setError('');
    try {
      const nextRecords = await lookerHttp.getLook(lookId);
      setRecords(nextRecords);
    } catch (err) {
      console.error(err);
      setError(axiosErrorToString(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => void loadRecords(), [version, lookId]);

  const columns: {title: string, dataIndex: string, key: string}[] = [];

  const dataSource = Array.isArray(records) ? records.map((record) => {
    for (const [key, value] of Object.entries(record)) {
      if (value !== null && !isNaN(value as any) && value.toString().indexOf('.') !== -1) {
        record[key] = +(+value).toFixed(4);
      }
      if (key.includes('.credit_id')) {
        record[key] = creditCodes[value] || record[key];
      }
    }
    return record;
  }) : [];

  if (records[0]) {
    for (const [key] of Object.entries(records[0])) {
      const title = (key.split('.').pop() || '')
        .replaceAll('_', ' ')
        .split(' ')
        .map(word => word[0].toUpperCase() + word.slice(1))
        .join(' ');
      columns.push({
        title,
        dataIndex: key,
        key,
      });
    }
  }

  const showTable = !loading && !error;

  return (
    <div className={cls.wrap}>
      <div className={cls.title}>{title}</div>
      {loading && <Loader />}
      {showTable && <Table dataSource={dataSource} columns={columns} />}
      <ErrorMessage text={error} className={cls.error} />
    </div>
  );
};

const useStyles = makeStyles({
  wrap: {},
  title: {
    fontSize: '16px',
    lineHeight: '16px',
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  error: {
    marginTop: -5,
    marginBottom: 15,
  },
});
